Vendd.Scripts.load(function () {
 
    if ($('.x-off-canvas-menu').length <= 0)
        return;


        $(window).resize(function () {
            attachToCanvasMenu();
        });
    

    var isMoved = false;
    
    if (window.innerWidth < 1470) {
        
            $('.header-usps-list').detach().prependTo('.js-canvas-menu').show();
            if ($('.x-currency-selector').length > 0)
                $('.x-currency-selector').detach().prependTo('.js-canvas-menu').show();
            $('.x-call-me-back-widget').detach().prependTo('.js-canvas-menu').show();
            $('.js-main-menu').detach().prependTo('.js-canvas-menu').show();
            $('.header-region .x-language-selector').detach().prependTo('.js-canvas-menu').show();
            isMoved = true;
        
    }

    function attachToCanvasMenu() {

        if (window.innerWidth < 1470) {
            if (!isMoved) {
                $('.header-usps-list').detach().prependTo('.js-canvas-menu').show();

                if ($('.x-currency-selector').length > 0)
                    $('.x-currency-selector').detach().prependTo('.js-canvas-menu').show();

                $('.x-call-me-back-widget').detach().prependTo('.js-canvas-menu').show();
                $('.js-main-menu').detach().prependTo('.js-canvas-menu').show();
                $('.header-region .x-language-selector').detach().prependTo('.js-canvas-menu').show();

                isMoved = true;
            }
        } else {
            if (isMoved) {
                (function placeLang() {
                    var $srch = $('.header-template-one .inner-area-three .js-main-menu.search-wrapper');
                    if ($srch.length) {
                        // don't scope to .off-canvas-menu; it may not be there anymore
                        $('.x-language-selector').detach().insertBefore($srch).show();
                    } else {
                        // try again shortly in case the search nav hasn't rendered yet
                        setTimeout(placeLang, 100);
                    }
                })();

                if ($('.x-currency-selector').length > 0)
                    $('.x-currency-selector').detach().insertBefore('.x-sitelogo');

                $('.js-main-menu').detach().appendTo('.header-template-one .inner-area-three');
                $('.x-call-me-back-widget').detach().insertAfter('.x-login-widget');
                $('.header-usps-list').detach().appendTo('.header-template-one .inner-area-one');
                isMoved = false;
                $("html").removeClass("show-canvas");
                $('.site-overlay').hide();
            }
        }
    }

});
